import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import axiosInstance from "../../httpService/httpService";

export const fetchDashboardStats = createAsyncThunk(
  "dashboard/fetchDashboardStats",
  async () => {
    const token = localStorage.getItem("authToken");

    const response = await axiosInstance.get("/fetch-dashboard-stats", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.data) {
      throw new Error("Failed to fetch dashboard stats");
    }
    const data = await response;
    return data;
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    stats: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardStats.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchDashboardStats.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.stats = action.payload;
      })
      .addCase(fetchDashboardStats.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default dashboardSlice.reducer;
